import React from 'react';
import logoFull from './assets/logo-upsellerate.png';

const UPSELLerateLogo = ({ width = 200, className = "" }) => (
  <div className={`upsellerate-logo ${className}`}>
    <img 
      src={logoFull} 
      alt="UPSELLerate AI" 
      style={{ 
        width: `${width}px`,
        height: 'auto',
        display: 'block',
        objectFit: 'contain'
      }}
    />
  </div>
);

export default UPSELLerateLogo;
